module.exports = __webpack_public_path__ + "img/konfigurasi_batas_saldo.04274487.svg";